import DashboardJourneyProgress from './DashboardJourneyProgress';

export default DashboardJourneyProgress;
